import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BankAccountsService } from '../../../../../../services/financial-accounts/bank-accounts.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HistoricalBalance, UnifiedBankAccount } from '../../../../../../models/entities/unified-bank-account';

export interface PlaidBalanceHistoryDialogInput
{
    unifiedBankAccount: UnifiedBankAccount;
}

export interface PlaidBalanceHistoryDialogResult
{
    success: boolean;
}

@UntilDestroy()
@Component({
    selector: 'app-plaid-balance-history-dialog',
    templateUrl: './plaid-balance-history-dialog.component.html',
})
export class PlaidBalanceHistoryDialogComponent
{
    loading = true;
    history: HistoricalBalance[] = [];

    constructor(
            private _dialogRef: MatDialogRef<PlaidBalanceHistoryDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public data: PlaidBalanceHistoryDialogInput,
            private bankAccountsService: BankAccountsService,
    ) {
        this.bankAccountsService.getPlaidBalanceHistory(this.data.unifiedBankAccount.organizationId, this.data.unifiedBankAccount.id).pipe(untilDestroyed(this)).subscribe((history) => {
            this.history = history;
            this.loading = false;
        });
    }
}
